import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useToggle } from "__barrel_optimize__?names=useToggle!=!react-use";
import { ViewVisibilityHeaderToggle } from "../shared/ViewVisibilityHeaderToggle";
export const ViewVisibilitySection = /*#__PURE__*/ memo((param)=>{
    let { toggles, onToggleShowingOptions, id, label, initialShowOptions } = param;
    const [showOptions, setShowOptions] = useToggle(initialShowOptions);
    const onToggle = useCallback(()=>{
        onToggleShowingOptions(!showOptions);
        setShowOptions(!showOptions);
    }, [
        showOptions,
        setShowOptions,
        onToggleShowingOptions
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ViewVisibilityHeaderToggle, {
                id: id,
                label: label,
                onToggle: onToggle,
                isToggleOn: showOptions
            }),
            showOptions && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "my-2 h-px w-full bg-grey-5"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col gap-1",
                        children: toggles
                    })
                ]
            })
        ]
    });
});
ViewVisibilitySection.displayName = "ViewVisibilitySection";
